module.exports = __webpack_public_path__ + "img/500.f4e66f06.jpg";